import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Label, Row } from "reactstrap"
import { Formik, Form, Field, ErrorMessage } from "formik"
import { useNavigate } from "react-router-dom"
import {
  addEmailsSchema,
} from "components/Common/validation"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"

import Spinners from "components/Shared/Spinners"

import { showAlert } from "store/reducers/alertReducer"
import {
  getGlobalSettingByType,
  updateGlobalSettingByType,
} from "store/actions/globalSettingAction"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"

const initialValues = {
  backgroundEmails: "",
}

const AddEmail = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Add Emails | Sign Burger")

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, isLoading, globalSettings } = useSelector(
    state => state.GlobalSettings
  )

  const [formValues, setFormValues] = useState(initialValues)

  const { userRole, accountType } = useSelector(state => state.Login)
  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    edit: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      31,
      "add_emails_1",
      accountType
    )

    const isPermissionEdit = isPermissionEnabled(
      userRole,
      31,
      "add_emails_3",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  useEffect(() => {
    fetchGlobalSettings()
  }, [])

  useEffect(() => {
    const settings = globalSettings?.globalSettings
    if (settings) {
      setFormValues({
        backgroundEmails: settings.backgroundEmails,
      })
    }
  }, [globalSettings])

  const fetchGlobalSettings = () => {
    const payload = {
      type: "globalSettings",
    }
    dispatch(getGlobalSettingByType(payload))
  }

  const handleOnSubmit = values => {
    const { backgroundEmails } = values
    const existingSettings = globalSettings?.globalSettings || {}

    const payload = {
      id: globalSettings._id,
      type: "globalSettings",
      globalSettings: {
        backgroundEmails,
        minimumOrderAmount: Number(existingSettings.minimumOrderAmount) || 0,
        maximumOrderAmount: Number(existingSettings.maximumOrderAmount) || 0,
        minimumOrderAmountErrorEn:
          existingSettings.minimumOrderAmountErrorEn || "",
        minimumOrderAmountErrorAr:
          existingSettings.minimumOrderAmountErrorAr || "",
        maximumOrderAmountErrorEn:
          existingSettings.maximumOrderAmountErrorEn || "",
        maximumOrderAmountErrorAr:
          existingSettings.maximumOrderAmountErrorAr || "",
        qrCodeBaseUrl: existingSettings.qrCodeBaseUrl || "",
        ratingQrBaseUrl: existingSettings.ratingQrBaseUrl || "",
      },
    }

    dispatch(updateGlobalSettingByType(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  if (loading) return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Card>
          <CardBody>
            <Formik
              initialValues={formValues}
              enableReinitialize={true}
              validationSchema={addEmailsSchema()}
              onSubmit={handleOnSubmit}
            >
              {({ values, errors, touched }) => (
                <Form>
                  <Row>
                    <Col md={6}>
                      <div className="form_field">
                        <Label
                          htmlFor="backgroundEmails"
                          className="col col-form-label"
                        >
                          <span className="text-danger">*</span>{" "}
                          {t(
                            "Background Emails(eg. example@gmail.com, example2@gmail.com)"
                          )}
                        </Label>
                        <Field
                          name="backgroundEmails"
                          type="text"
                          id="backgroundEmails"
                          placeholder={t("Background Emails")}
                          className={`form-control ${
                            touched.backgroundEmails && errors.backgroundEmails
                              ? "is-invalid"
                              : ""
                          }`}
                        />
                        <TextError name="backgroundEmails" />
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="d-flex justify-content-end">
                        <Button
                          type="button"
                          color="secondary"
                          onClick={() => navigate(-1)}
                        >
                          {t("Cancel")}
                        </Button>
                        {usersPermissions.edit && (
                          <Button
                            className="mx-2"
                            type="submit"
                            color="success"
                            disabled={isLoading}
                          >
                            {t("Save")}
                          </Button>
                        )}
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default AddEmail
